export default {
  "site.name": "爱液视频",
  "site.slogan": "官方正版视频平台",
  "site.description": "爱液视频官网是您值得信赖的官方视频平台，提供海量高清正版视频内容，支持多终端流畅播放。",
  "nav.home": "首页",
  "nav.category": "分类",
  "nav.about": "关于我们",
  "nav.join": "加入会员",
  "nav.login": "登录",
  "footer.rights": "© 2026 爱液视频 版权所有",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.contact": "联系我们",
  "footer.about": "关于我们",
  "footer.follow": "关注我们",
  "footer.quickLinks": "快速链接",
  "footer.customerService": "客服中心",
  "footer.help": "帮助中心",
  "footer.feedback": "意见反馈",
  "breadcrumb.home": "首页",
  "scrollTop": "回到顶部",
  "loading": "加载中...",
  "error": "加载失败，请重试",
  "retry": "重试",
};